import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './auth/AuthContext';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { TermsGate } from './auth/TermsGate';
import { AdminRoute } from './auth/AdminRoute';
import { AuthCallback } from './auth/AuthCallback';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { FaqPage } from './pages/FaqPage';
import { DocsPage } from './pages/DocsPage';
import { TryOutPage } from './pages/TryOutPage';
import { UsagePage } from './pages/UsagePage';
import { AdminPage } from './pages/AdminPage';
import { TermsPage } from './pages/TermsPage';


const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#000000',
    },
  },
  typography: {
    fontFamily: '"DM Sans", sans-serif',
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/callback" element={<AuthCallback />} />
              <Route
                path="/terms"
                element={
                  <ProtectedRoute>
                    <TermsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                element={
                  <ProtectedRoute>
                    <TermsGate />
                  </ProtectedRoute>
                }
              >
                <Route
                  path="/"
                  element={<DashboardPage />}
                />
                <Route
                  path="/faq"
                  element={<FaqPage />}
                />
                <Route
                  path="/docs"
                  element={<DocsPage />}
                />
                <Route
                  path="/docs/:slug/try"
                  element={<TryOutPage />}
                />
                <Route
                  path="/docs/:slug"
                  element={<DocsPage />}
                />
                <Route
                  path="/usage"
                  element={<UsagePage />}
                />
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminPage />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/quotas"
                  element={
                    <AdminRoute>
                      <AdminPage />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/activity"
                  element={
                    <AdminRoute>
                      <AdminPage />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/apis"
                  element={
                    <AdminRoute>
                      <AdminPage />
                    </AdminRoute>
                  }
                />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
